<template>
    <div>
        <el-upload
            :action="actionUrl"
            list-type="picture-card"
            :limit="limit"
            :file-list="type == 'compile' ? fileLists : fileList"
            :on-success="(res, file) => shujiAvatar(res, file)"
            :before-upload="beforeAvatarUpload"
            :on-exceed="handleExceed"
        >
            <i slot="default" class="el-icon-plus"></i>
            <div
                slot="file"
                slot-scope="{ file }"
                style="width: 100%; height: 100%"
            >
                <img
                    class="el-upload-list__item-thumbnail"
                    :src="file.path"
                    alt
                />
                <span class="el-upload-list__item-actions">
                    <span
                        class="el-upload-list__item-preview"
                        @click="handlePictureCardPreview(file)"
                    >
                        <i class="el-icon-zoom-in"></i>
                    </span>
                    <span
                        v-if="!disabled"
                        class="el-upload-list__item-delete"
                        @click="handleDownload(file)"
                    >
                        <i class="el-icon-download"></i>
                    </span>
                    <span
                        v-if="!disabled"
                        class="el-upload-list__item-delete"
                        @click="handleRemove(file)"
                    >
                        <i class="el-icon-delete"></i>
                    </span>
                </span>
            </div>
        </el-upload>
        <el-dialog :visible.sync="dialogVisible" :modal="false">
            <img width="100%" :src="dialogImageUrl" alt />
        </el-dialog>
    </div>
</template>

<script>
import baseURL from "@/api/baseURL"
export default {
    data() {
        return {
          actionUrl:baseURL+
                "/ypt/controller/uploadVotePic/info/uploadPartyPhoto",
            fileList: [],
            dialogImageUrl: "",
            dialogVisible: false,
            disabled: false,
        }
    },
    props: {
        fileLists: {
            type: Array,
            default: [],
        },
        type: {
            type: String,
            default: "",
        },
        //限制上传的张数
        limit: {
            type: Number,
            default: 1000,
        },
    },

    methods: {
        // 上传照片相关
        shujiAvatar(res, file, item) {
            console.log("res", res)
            //
            if (this.fileLists && this.fileLists.length > 0) {
                this.fileList = this.fileLists
            }
            this.fileList.push({
                name: res.content.name,
                path: res.content.path,
            })
            this.$emit("success", this.fileList)
            // this.$set(item, "photo", item.photo + ";" + res.content.pash);
            // this.fileList.push({
            //   path:res.content.path
            // })
            // item.photo = res.content.path;
        },
        //删除 找到对应点击的图片索引
        handleRemove(file) {
            //
            if (this.fileLists && this.fileLists.length > 0) {
                this.fileList = this.fileLists
            }
            let index = this.fileList.findIndex(
                (item) => item.name == file.name
            )
            this.fileList.splice(index, 1)
            this.$emit("deleteImg", this.fileList)
        },
        handleDownload(file) {
            console.log(file)
            window.open(file.path)
        },
        beforeAvatarUpload(file) {
            // const isJPG = file.type === "image/jpeg";
            // const isLt2M = file.size / 1024 / 1024 < 2;
            // if (!isJPG) {
            //   this.$message.error("上传头像图片只能是 JPG 格式!");
            // }
            // if (!isLt2M) {
            //   this.$message.error("上传头像图片大小不能超过 2MB!");
            // }
            // return isJPG && isLt2M;
        },
        handlePictureCardPreview(file) {
            this.dialogImageUrl = file.path
            this.dialogVisible = true
        },
        handleExceed(files, fileList) {
            this.$message.warning(`最多只能上传 ${this.limit} 个图片  `)
        },
    },
    // created(){
    //   console.log(this.fileLists);
    //   this.fileList = this.fileLists
    // },
    // watch:{
    //   fileLists(newV){
    //     console.log('fileLists=>',fileLists);
    //     this.fileList = newV
    //   }
    // }
}
</script>